import { render, staticRenderFns } from "./AccountInvestigation.vue?vue&type=template&id=981272f2&scoped=true&"
import script from "./AccountInvestigation.vue?vue&type=script&lang=js&"
export * from "./AccountInvestigation.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvestigation.vue?vue&type=style&index=0&id=981272f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981272f2",
  null
  
)

export default component.exports